// extracted by mini-css-extract-plugin
export default {"__banner":"styles___banner__K9DTq","__container":"styles___container__ENj+K","__right_para":"styles___right_para__C+05u"};